export default __webpack_public_path__ + "static/media/No.6-8.d2e7db54.jpg";